import React, { useMemo } from "react";
import ContactCard from "./contactCard";
import ThemedCardComponent from "../../../genericComponents/themedCardCompoennt";

function ContactNudgeComponentCard({ contactsData, noHeading }) {
  const CONTACT_DATA = contactsData || [];

  const head_background_obj = [
    {
      head_class: "red_light",
      avatar_class: "ed40407a",
    },
    {
      head_class: "purple_light",
      avatar_class: "A685E2",
    },
    {
      head_class: "green_light",
      avatar_class: "86C8BC",
    },
    {
      head_class: "cream_light",
      avatar_class: "EFB495",
    },
    {
      head_class: "blue_light",
      avatar_class: "8EACCD",
    },
    {
      head_class: "grey_light",
      avatar_class: "d5d5d5",
    },
  ];

  // Group contacts into pairs for side-by-side display
  const contactPairs = useMemo(() => {
    const pairs = [];
    for (let i = 0; i < CONTACT_DATA.length; i += 2) {
      pairs.push(CONTACT_DATA.slice(i, i + 2));
    }
    return pairs;
  }, [CONTACT_DATA]);

  return (
    <ThemedCardComponent
      title={
        <div className="sideCardContentTitle m-2" >
          Contacts
        </div>
      }
      description={
        <div
          className="contact_wrapper"
          style={{ backgroundColor: "transparent" }}
        >
          <div className="contact_block custom_card_block">
            <div className="row">
              <div className="contact_tiles_block">
                <div className="contact_wrapper mt-3" id="">
                  {contactPairs?.length > 0 ? (
                    contactPairs.map((pair, pairIndex) => (
                      <div key={`pair-${pairIndex}`} className="row mb-4">
                        {pair.map((contact, index) => {
                          const bgIndex =
                            (pairIndex * 2 + index) %
                            head_background_obj.length;
                          const backgroundStyle = head_background_obj[4];
                          return (
                            <div
                              key={contact.contact_name}
                              className="col-md-6"
                            >
                              <ContactCard
                                contact={contact}
                                headClass={backgroundStyle.head_class}
                                avatarClass={backgroundStyle.avatar_class}
                              />
                            </div>
                          );
                        })}
                      </div>
                    ))
                  ) : (
                    <div
                      style={{
                        minHeight: "20vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      No Contacts Available
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
}

export default React.memo(ContactNudgeComponentCard);
